// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'document-json';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.438 15.908a1.062 1.062 0 0 1-1.063 1.063H2.625a1.062 1.062 0 0 1-1.063-1.063V2.096a1.062 1.062 0 0 1 1.063-1.063h10.657c.277 0 .544.109.742.303l2.093 2.041a1.063 1.063 0 0 1 .32.761z' />
    <path d='M7.938 6.346h-.532a.998.998 0 0 0-1.062.916v.884a.89.89 0 0 1-.473.762l-1.121.644 1.12.644a.891.891 0 0 1 .474.762v.884a.997.997 0 0 0 1.062.916h.532m2.125-6.412h.53a.997.997 0 0 1 1.063.916v.884a.89.89 0 0 0 .473.762l1.121.644-1.12.644a.891.891 0 0 0-.474.763v.884a.997.997 0 0 1-1.062.915h-.531' />
  </g>
);

export const viewBox = '0 0 18 18';
